import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveDynamicComponent as _resolveDynamicComponent, openBlock as _openBlock, createBlock as _createBlock, normalizeStyle as _normalizeStyle, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = ["viewBox", "aria-labelledby"]
const _hoisted_2 = ["id"]

import { withDefaults, shallowRef, defineAsyncComponent } from 'vue'

interface Props {
  iconName?: string
  width?: number | string
  height?: number | string
  viewBox?: string
  color?: string
}


export default /*#__PURE__*/_defineComponent({
  __name: 'BaseIcon',
  props: {
    iconName: { default: 'forward' },
    width: { default: 19 },
    height: { default: 19 },
    viewBox: { default: '0 0 19 19' },
    color: { default: '#ffffff' }
  },
  setup(__props: any) {

const props = __props as { iconName: string, width: number | string, height: number | string, viewBox: string, color: string }



const loadedIcon = shallowRef(null)

loadedIcon.value = defineAsyncComponent(() =>
  import(
    /* webpackChunkName: "SvgIcons" */
    /* webpackPreload: true */
    './icons/icons-chunk-maker'
  ).then(getIcon => getIcon.default(props.iconName))
)

const getSVGStyle = () => {
  return `stroke: ${props.color} !important`
}

return (_ctx: any,_cache: any) => {
  return (_unref(loadedIcon))
    ? (_openBlock(), _createElementBlock("svg", {
        key: 0,
        xmlns: "http://www.w3.org/2000/svg",
        width: "105%",
        height: "105%",
        viewBox: __props.viewBox,
        preserveAspectRatio: "xMidYMid meet",
        "aria-labelledby": __props.iconName,
        role: "presentation",
        style: _normalizeStyle(getSVGStyle())
      }, [
        _createElementVNode("title", {
          id: __props.iconName,
          lang: "en"
        }, _toDisplayString(__props.iconName) + " icon", 9, _hoisted_2),
        (_openBlock(), _createBlock(_resolveDynamicComponent(_unref(loadedIcon))))
      ], 12, _hoisted_1))
    : _createCommentVNode("", true)
}
}

})